module.exports = __webpack_public_path__ + "img/blog5.49c7c045.jpg";